import { useState } from 'react';
import { setSesion } from './apiAuth';

export default function Login() {
  const [usuario, setUsuario] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const r = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ usuario, password }),
      });
      const data = await r.json();
      if (!r.ok) {
        setError(data.error || 'Error de acceso');
        return;
      }
      setSesion(data.token, data.usuario);
      // Recarga completa (no solo actualizar el estado en memoria) para que
      // ningún estado de una sesión anterior en este mismo navegador (menu
      // activo, formularios abiertos, listas cargadas de otro usuario)
      // sobreviva al cambio de sesión.
      window.location.reload();
    } catch {
      setError('Error de conexión con el servidor');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#0f4c5c', fontFamily: "'Segoe UI', Tahoma, sans-serif" }}>
      <form onSubmit={submit} style={{ background: 'white', padding: '40px 36px 32px', borderRadius: 14, width: 360, maxWidth: 'calc(100vw - 104px)', boxShadow: '0 20px 50px rgba(0,0,0,0.35)' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, marginBottom: 28 }}>
          <img src="/logo-sih.svg" alt="" style={{ height: 56, width: 56, flexShrink: 0, display: 'block' }} />
          <div style={{ textAlign: 'left', minWidth: 0 }}>
            <h1 style={{ margin: 0, color: '#1a3a6e', fontSize: 'clamp(20px, 6vw, 26px)', fontWeight: 700, letterSpacing: '-0.3px', lineHeight: 1.15 }}>Sistema Integral</h1>
            <div style={{ marginTop: 4, color: '#1a3a6e', fontSize: 'clamp(20px, 6vw, 26px)', fontWeight: 700, letterSpacing: '-0.3px', lineHeight: 1.15 }}>de Hipotecas</div>
          </div>
        </div>
        {error && <div style={{ color: '#dc2626', marginBottom: 16, fontSize: 14, textAlign: 'center' }}>{error}</div>}
        <div style={{ marginBottom: 14 }}>
          <label style={{ display: 'block', marginBottom: 4, fontSize: 13, color: '#4b5563' }}>Usuario</label>
          <input value={usuario} onChange={e => setUsuario(e.target.value)} style={{ width: '100%', padding: '10px 12px', boxSizing: 'border-box', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14, outline: 'none' }} />
        </div>
        <div style={{ marginBottom: 22 }}>
          <label style={{ display: 'block', marginBottom: 4, fontSize: 13, color: '#4b5563' }}>Contraseña</label>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} style={{ width: '100%', padding: '10px 12px', boxSizing: 'border-box', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14, outline: 'none' }} />
        </div>
        <button disabled={loading} type="submit" style={{ width: '100%', padding: 12, backgroundColor: '#f97316', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 'bold', fontSize: 15, boxShadow: '0 4px 10px rgba(249,115,22,0.35)' }}>
          {loading ? 'Ingresando...' : 'Ingresar'}
        </button>
        <div style={{ textAlign: 'center', marginTop: 24, fontSize: 12, color: '#d1d5db' }}>© 2026 · v 2.0 Rueli TI</div>
      </form>
    </div>
  );
}
